import React from 'react';
import { StarIcon } from 'lucide-react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function HeroSection() {
  return <section className="w-full py-6 md:py-10 px-4 relative overflow-hidden bg-[#000000]" data-id="element-159">
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-yellow-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-160"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10 bg-[#000000]" data-id="element-161">
        <div className="inline-block bg-yellow-400/10 border border-yellow-400/30 rounded-full px-4 py-1.5 mb-4" data-id="element-162">
          <span className="text-yellow-400 font-bold text-xs md:text-sm tracking-wide" data-id="element-163">
            🧭 GUÍA REAL PARA ESTA ETAPA
          </span>
        </div>

        <h1 className="text-2xl md:text-4xl font-black font-heading leading-tight mb-3 text-[#FFFFFF]" data-id="element-164">
          👉 Acompaña a tus padres sin perderte en el proceso
        </h1>

        <p className="text-base md:text-lg italic mb-2 font-body text-[#FFFFFF]" data-id="element-165">
          Un sistema claro para saber qué hacer con tus padres, sin improvisar
          ni sentirte desbordado
        </p>

        <div className="my-5 cursor-pointer relative group" onClick={scrollToPricing} data-id="element-166">
          <img src="https://cdn.magicpatterns.com/uploads/9g1wf4mTNJnasH9HHxww8D/MOCKUP_1_PNG.png" alt="MegaPack Afrontar la Vejez de Tus Padres - 6 tomos completos" width="672" height="672" fetchPriority="high" className="w-full max-w-xl mx-auto drop-shadow-[0_15px_35px_rgba(0,0,0,0.5)] group-hover:scale-[1.02] transition-transform duration-500" data-id="element-167" />
        </div>

        <p className="text-sm md:text-base mb-6 max-w-2xl mx-auto font-body leading-relaxed text-[#83DCEA]" data-id="element-168">
          Nadie te enseñó cómo hacer esto… pero puedes aprender a hacerlo bien
        </p>

        <p className="md:text-lg mb-6 max-w-2xl mx-auto font-body italic text-[#D9D9D9] text-[14px] font-[400]" data-id="element-169">
          Toma decisiones claras, reduce el conflicto familiar y acompaña esta
          etapa con más orden, calma y seguridad desde las primeras semanas.
        </p>

        <button onClick={scrollToPricing} className="w-full md:w-auto bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black md:text-xl px-8 py-4 rounded-xl shadow-[0_0_25px_rgba(250,204,21,0.3)] animate-pulse-glow transition-all duration-300 cursor-pointer font-heading text-[16px]" data-id="element-170">
          👉 QUIERO MI MEGAPACK AHORA
        </button>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 mt-4 text-xs md:text-sm text-gray-400 font-medium" data-id="element-171">
          <span className="flex items-center gap-1" data-id="element-172">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-173">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1" data-id="element-174">
            💳 Pagas en la moneda de tu país
          </span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-8 border-t border-b border-gray-800 py-5" data-id="element-175">
          <div className="text-center" data-id="element-176">
            <p className="text-2xl md:text-3xl font-black font-heading text-yellow-400" data-id="element-177">
              +2.000
            </p>
            <p className="text-[10px] md:text-xs text-gray-400 mt-1 uppercase tracking-wider font-semibold leading-tight" data-id="element-178">
              personas acompañando
            </p>
          </div>
          <div className="text-center" data-id="element-179">
            <p className="text-2xl md:text-3xl font-black font-heading text-yellow-400" data-id="element-180">
              6
            </p>
            <p className="text-[10px] md:text-xs text-gray-400 mt-1 uppercase tracking-wider font-semibold leading-tight" data-id="element-181">
              tomos completos
            </p>
          </div>
          <div className="text-center" data-id="element-182">
            <p className="text-2xl md:text-3xl font-black font-heading text-yellow-400" data-id="element-183">
              4.9/5
            </p>
            <p className="text-[10px] md:text-xs text-gray-400 mt-1 uppercase tracking-wider font-semibold leading-tight" data-id="element-184">
              calificación ⭐
            </p>
          </div>
          <div className="text-center" data-id="element-185">
            <p className="text-2xl md:text-3xl font-black font-heading text-yellow-400" data-id="element-186">
              🌍
            </p>
            <p className="text-[10px] md:text-xs text-gray-400 mt-1 uppercase tracking-wider font-semibold leading-tight" data-id="element-187">
              Mundo hispanohablante
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mt-6 mb-8" data-id="element-188">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-2.5 text-center" data-id="element-189">
            <span className="text-xl block mb-1" data-id="element-190">📄</span>
            <p className="text-[10px] md:text-xs font-semibold text-gray-300 leading-tight" data-id="element-191">
              100% digital (PDF)
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-2.5 text-center" data-id="element-192">
            <span className="text-xl block mb-1" data-id="element-193">⚡</span>
            <p className="text-[10px] md:text-xs font-semibold text-gray-300 leading-tight" data-id="element-194">
              Acceso inmediato
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-2.5 text-center" data-id="element-195">
            <span className="text-xl block mb-1" data-id="element-196">🌍</span>
            <p className="text-[10px] md:text-xs font-semibold text-gray-300 leading-tight" data-id="element-197">
              Cualquier país
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-2.5 text-center" data-id="element-198">
            <span className="text-xl block mb-1" data-id="element-199">👨‍👩‍👧‍👦</span>
            <p className="text-[10px] md:text-xs font-semibold text-gray-300 leading-tight" data-id="element-200">
              Para adultos con padres
            </p>
          </div>
        </div>

        <div className="space-y-2.5" data-id="element-201">
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-4 text-left" data-id="element-202">
            <div className="flex gap-1 mb-1.5" data-id="element-203">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-204" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-205" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-206" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-207" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-208" />
            </div>
            <p className="text-gray-300 italic font-body text-sm md:text-base" data-id="element-209">
              "Dejé de sentirme perdido. Ahora sé qué hacer y cuándo hacerlo."
            </p>
            <p className="text-xs text-gray-500 mt-1.5 font-semibold" data-id="element-210">
              — Laura M.
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-4 text-left" data-id="element-211">
            <div className="flex gap-1 mb-1.5" data-id="element-212">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-213" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-214" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-215" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-216" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-217" />
            </div>
            <p className="text-gray-300 italic font-body text-sm md:text-base" data-id="element-218">
              "Pasamos de discutir todo… a organizarnos mejor como familia"
            </p>
            <p className="text-xs text-gray-500 mt-1.5 font-semibold" data-id="element-219">
              — Andrés R.
            </p>
          </div>
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-4 text-left" data-id="element-220">
            <div className="flex gap-1 mb-1.5" data-id="element-221">
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-222" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-223" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-224" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-225" />
              <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-226" />
            </div>
            <p className="text-gray-300 italic font-body text-sm md:text-base" data-id="element-227">
              "Lo que más me ayudó fue tener un sistema claro, no improvisar"
            </p>
            <p className="text-xs text-gray-500 mt-1.5 font-semibold" data-id="element-228">
              — Carolina V.
            </p>
          </div>
        </div>
      </div>
    </section>;
}